<script>
    import Flatpickr from 'svelte-flatpickr';
    import { date } from '../store/search';

    export let placeholder;
    export let onRequest;

    const flatpickrOptions = {
        element: '#my-picker',
        enableTime: false,
        altInput: true,
        minDate: onRequest
            ? new Date().setDate(new Date().getDate() + 2)
            : new Date().setDate(new Date().getDate() + 1),
        wrap: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d',
    };
</script>

<svelte:head>
    <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css"
    />
    <link
        rel="stylesheet"
        type="text/css"
        href="https://npmcdn.com/flatpickr/dist/themes/material_default.css"
    />
</svelte:head>

<Flatpickr options={flatpickrOptions} bind:value={$date} element="#my-picker">
    <div class="flatpickr date-time-field" id="my-picker">
        <input type="text" {placeholder} data-input />
    </div>
</Flatpickr>
